exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-sub-title{padding:25px 15px}.tags-container{padding:5px 15px}.tags-container .zan-tag+.zan-tag{margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-72098bef!./~/vue-loader/lib/selector.js?type=styles&index=0!./docs/examples/tag.vue
// module id = 232
// module chunks = 0